'use client';

import { Counter } from '@/elements/counter/counter.component';
import { CounterContainer } from './analytics.elements';

const Analytics = ({
  data: { lecturersCount, educationsCount, registrationsCount, averageEducationGrade },
}) => {
  return (
    <CounterContainer>
      <Counter title="Edukacija" value={educationsCount} />
      <Counter title="Predavača" value={lecturersCount} />
      <Counter title="Polaznika" value={registrationsCount} />
      <Counter rating title="Prosječna ocjena" value={averageEducationGrade} decimals={2} />
    </CounterContainer>
  );
};

export { Analytics };
